import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, TerminalImage } from "./TerminalImage";
import { ARTICLES } from "../../data/articles";

const CARD_BLURBS = {
  "private-credit-vs-bank-lending":
    "Comparing covenant flexibility, loan turnaround speed, and custom amortisation against standard APRA-regulated lending books.",
  "fees-and-conflicts":
    "How management and establishment fees are structured, and where manager interests can diverge from investor interests.",
  "valuations-asic-rep-814":
    "Assessing independent asset valuations, fee allocations, and the conflict disclosures flagged by the regulator.",
  "real-estate-credit":
    "Analysing first-mortgage security, mezzanine development debt, and residual stock facilities across Australian CRE.",
  "corporate-facilities":
    "Cash flow lending, acquisition finance and bespoke term facilities written outside the major banks.",
  "regulatory-watch":
    "Tracking ASIC findings, enforcement actions and disclosure standards as the sector's regulatory perimeter tightens.",
};

export const Explainers = () => (
  <section id="terminal-asic" className="py-20 border-b border-line max-w-6xl mx-auto px-6" data-testid="explainers-section">
    <div className="mb-10">
      <span className="text-xs font-mono text-cy uppercase tracking-widest">[03] KNOWLEDGE PILLARS</span>
      <h2 className="font-display text-4xl text-white uppercase mt-2">Essential Credit Topics</h2>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {ARTICLES.map((a) => (
        <Link
          key={a.slug}
          to={`/explainers/${a.slug}`}
          data-testid={`explainer-card-${a.slug}`}
          className="p-6 rounded-xl bg-surface border border-line hover:border-cy/40 transition-colors group flex flex-col"
        >
          <div className="text-xs font-mono text-cy font-bold">{a.tag}</div>
          <h3 className="font-display text-xl text-white uppercase mt-2 group-hover:text-cy transition-colors">
            {a.title}
          </h3>
          <p className="text-xs text-mut font-body mt-2 leading-relaxed">{CARD_BLURBS[a.slug]}</p>
          <span className="mt-auto pt-4 text-slate-500 inline-flex items-center gap-1 text-[10px] font-mono">
            READ EXPLAINER <ArrowUpRight className="w-3 h-3" />
          </span>
        </Link>
      ))}
    </div>

    <div className="mt-8 rounded-xl border border-line p-6 bg-navy-alt flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="w-full md:w-1/3 rounded-lg overflow-hidden border border-line">
        <TerminalImage
          src={IMAGES.explainer}
          alt="Capital structure schematic"
          testId="explainer-visual"
          className="aspect-[16/6] p-4"
        >
          <span className="text-[10px] font-mono text-cy bg-navy/90 px-2 py-1 rounded border border-cy/30 w-max">
            DUE DILIGENCE BLUEPRINT
          </span>
        </TerminalImage>
      </div>
      <div className="md:w-2/3">
        <h4 className="font-display text-xl text-white uppercase">Critical Questions for Wholesale Allocators</h4>
        <p className="text-xs text-mut font-body mt-2 leading-relaxed">
          What is the fund's loan default workout process? How frequently are independent valuations required?
          Are establishment fees rebated to the fund? How are related-party exposures disclosed?
        </p>
      </div>
    </div>
  </section>
);
